import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-hthpfluidloss-vertical',
  standalone: false,
  templateUrl: './hthpfluidloss-vertical.component.html',
  styleUrl: '../../job-request-column-report.component.scss'
})
export class HthpfluidlossVerticalComponent  {
  @Input() hthpfluidlossTest:any;
}
